import React, { useState } from "react";
import "./Finder.css";

const audioFiles = [
  { name: "Composition 1", src: "/audio/compo1.mp3" },
  { name: "Composition 2", src: "/audio/compo2.mp3" },
  { name: "Composition 3", src: "/audio/compo3.mp3" },
  // ajoute d'autres fichiers ici
];

export default function Finder({ onClose }) {
  const [currentAudio, setCurrentAudio] = useState(null);

  const playAudio = (src) => {
    if (currentAudio) currentAudio.pause();
    const audio = new Audio(src);
    setCurrentAudio(audio);
    audio.play();
  };

  return (
    <div className="finder-overlay">
      <div className="finder-window">
        <div className="finder-topbar">
          <div className="finder-buttons">
            <span className="close" onClick={onClose}></span>
            <span className="minimize"></span>
            <span className="maximize"></span>
          </div>
          <span className="finder-title">Musique</span>
        </div>
        <div className="finder-content">
          {audioFiles.map((file, index) => (
            <div key={index} className="finder-file">
              <img src="/audio_icon.png" alt={file.name} />
              <span>{file.name}</span>
              <button onClick={() => playAudio(file.src)}>▶️</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
